import React from 'react';
import {NavLink} from "react-router-dom";
import { ValidatorForm, TextValidator} from 'react-material-ui-form-validator';
import PropTypes from 'prop-types';
import MuiPickersUtilsProvider from "material-ui-pickers/utils/MuiPickersUtilsProvider";
import MomentUtils from "material-ui-pickers/utils/moment-utils";
import moment from 'moment';

import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import withStyles from '@material-ui/core/styles/withStyles';
import LocationSearchInput from '../utils/LocationSearchInput'
import SearchSelect from '../utils/SearchSelect'
import Picker from '../utils/Picker'
import AutoSuggestSiret from '../utils/AutoSuggestSiret'


import 'moment/locale/fr';
moment.locale('fr');

const styles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    display: 'block', // Fix IE11 issue.
    marginLeft: theme.spacing.unit * 3,
    marginRight: theme.spacing.unit * 3,
    [theme.breakpoints.up(400 + theme.spacing.unit * 3 * 2)]: {
      width: 400,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme.spacing.unit * 3}px`,
  },
  avatar: {
    margin: theme.spacing.unit,
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE11 issue.
    marginTop: theme.spacing.unit,
  },
  submit: {
    marginTop: theme.spacing.unit * 3,
  },
  button: {
    marginTop: theme.spacing.unit * 3,
  },
  input: {
    display: 'none',
  },
  media: {
    marginTop: theme.spacing.unit * 2,
    // ⚠️ object-fit is not supported by IE11.
    objectFit: 'cover',
  },
  marginDivier: {
    marginTop: theme.spacing.unit * 3,
  }
});

class EditInvoice extends React.Component {

  render() {
    return (
      <React.Fragment>
        <CssBaseline />
          <NavLink to={"/invoices/"} style={{ textDecoration: 'none' }}>
            <Button variant="outlined" size="large" >Retour</Button>
          </NavLink>
          <Paper className={this.props.classes.paper}>
            <MuiPickersUtilsProvider locale="fr" moment={moment} utils={MomentUtils}>
              <ValidatorForm onSubmit={this.props.handleFormSubmit} className={this.props.classes.form}>

                <Typography variant="headline">Informations</Typography>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Référence"
                            onChange={this.props.handleInputChange}
                            name="reference"
                            value={this.props.formData.reference}
                            validators={['required', 'matchRegexp:^[ 0-9A-Za-zàáâäçèéêëìíîïñòóôöùúûü-]*$']}
                            errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                      <Picker
                        label="Date"
                        onChange={this.props.handleDateChange("date")}
                        name="date"
                        value={this.props.formData.date}
                        validators={["required"]}
                        errorMessages={["ce champ est requis"]}
                        format="DD/MM/YYYY HH:mm"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={4} >
                    <FormControl margin="normal" required fullWidth>
                      <SearchSelect name="audits" label="Audit(s)" placeholder="Liste des audit(s)" defaultValue={this.props.formData.audits} options={this.props.auditsOption} data={this.props.audits} handleInputChange={this.props.handleInputChange} />
                      {(!this.props.valid) && <Typography color="error" gutterBottom noWrap>
                        {`Merci de sélectionner au minimum un audit validé`}
                        </Typography>}
                    </FormControl>
                  </Grid>
                </Grid>

                  <Typography variant="headline" className={this.props.classes.marginDivier}>Le client</Typography>

                  <Grid item xs={12} sm={6} md={4}>
                      <AutoSuggestSiret default={this.props.formData.customer_siret} options={this.props.listOfOrganisations} completeForm={this.props.completeForm}/>
                      {this.props.siretError && <Typography variant="body2" style={{color: "#f44336",fontWeight: "normal"}}>ce champ est requis</Typography>}
                  </Grid>
                  <Grid container spacing={24}>
                      <Grid item xs={12} sm={6} md={4}>
                          <LocationSearchInput name="customer_address" address={this.props.formData.customer_address} handleInputChange={this.props.handleInputChange} />
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                          <FormControl margin="normal" required fullWidth>
                              <TextValidator
                                  label="Nom"
                                  onChange={this.props.handleInputChange}
                                  name="customer_name"
                                  value={this.props.formData.customer_name}
                                  validators={['required', 'matchRegexp:^[ 0-9A-Za-zàáâäçèéêëìíîïñòóôöùúûü-]*$']}
                                  errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
                              />
                          </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4}>
                          <FormControl margin="normal" required fullWidth>
                              <TextValidator
                                  label="n° tva"
                                  onChange={this.props.handleInputChange}
                                  name="customer_tva"
                                  value={this.props.formData.customer_tva}
                                  validators={['required', 'matchRegexp:^[A-Z]{2}[ .-]?[0-9]{2}[ .-]?[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{3}$']}
                                  errorMessages={['ce champ est requis', 'TVA Intracommunautaireau format FR 12 345 678 123']}
                              />
                          </FormControl>
                      </Grid>
                  </Grid>

                <Typography variant="headline" className={this.props.classes.marginDivier}>Mes informations</Typography>

                <Grid item xs={12} md={4}>
                  <FormControl margin="normal" required fullWidth>
                      <LocationSearchInput name="seller_address" address={this.props.formData.seller_address} handleInputChange={this.props.handleInputChange} />
                  </FormControl>
                </Grid>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Nom"
                            onChange={this.props.handleInputChange}
                            name="seller_name"
                            value={this.props.formData.seller_name}
                            validators={['required', 'matchRegexp:^[ 0-9A-Za-zàáâäçèéêëìíîïñòóôöùúûü-]*$']}
                            errorMessages={['ce champ est requis', 'La valeur du champ est invalide']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="n° tva"
                            onChange={this.props.handleInputChange}
                            name="seller_tva"
                            value={this.props.formData.seller_tva}
                            validators={['required', 'matchRegexp:^[A-Z]{2}[ .-]?[0-9]{2}[ .-]?[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{3}$']}
                            errorMessages={['ce champ est requis', 'TVA Intracommunautaireau format FR 12 345 678 123']}
                        />
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} md={4}>
                    <FormControl margin="normal" required fullWidth>
                        <TextValidator
                            label="Siret"
                            onChange={this.props.handleInputChange}
                            name="seller_siret"
                            value={this.props.formData.seller_siret}
                            validators={['required', 'matchRegexp:^[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{3}[ .-]?[0-9]{5}$']}
                            errorMessages={['ce champ est requis', 'Le siret doit être au format 123 456 789 12345']}
                        />
                    </FormControl>
                  </Grid>
                </Grid>

                <Button

                      type="submit"
                      variant="raised"
                      color="primary"
                      className={this.props.classes.submit}
                      disabled={this.props.submitted}
                  >
                      {
                          (this.props.submitted && "Enregistrement en cours...") ||
                          (!this.props.submitted && "Enregister")
                      }
                  </Button>
              </ValidatorForm>
            </MuiPickersUtilsProvider>
          </Paper>
      </React.Fragment>
    );
  }
}

EditInvoice.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(EditInvoice);



// WEBPACK FOOTER //
// ./src/component/invoice/editInvoice.js